/* eslint-disable */
import {
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import Item from "../../utils/Item";
import PrecioVentaContadoLista from "./PrecioVentaContadoLista";

//
// ###########################################################################
//
const DatosTratamiento = ({ articulo, showPrecio = true }) => {

  //
  // ################################################################################
  //
  return (
    <>
      {articulo && (
        <>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                Tratamiento
              </Typography>

              <Grid container spacing={2}>
                <Item label="Descripción" value={articulo.descripcion} />
                <Item label="Marca" value={articulo.descripcion_tr_marca} />
                <Item label="Tipo" value={articulo.descripcion_tr_tipo} />
                <Item label="Tiempo de producción (días)" value={articulo.tiempo_produccion} />
              </Grid>
            </CardContent>
          </Card>

          {showPrecio && (
            <Card sx={{ mt: 2 }}>
              <CardContent>
                <PrecioVentaContadoLista precioVentaContado={articulo.precio_venta_contado} precioVentaLista={articulo.precio_venta_lista} />
              </CardContent>
            </Card>
          )}
        </>
      )}
    </>
  );
};
export default DatosTratamiento;
